// extracted by mini-css-extract-plugin
export default {"content":"PartnerWarehouses_content__-vGja","info":"PartnerWarehouses_info__Xp3uI"};